(function () {
  const selectors = {
    data: "script[data-protection-settings]",
  };

  let data = null;

  const parseScriptTag = ($script, remove = false) => {
    try {
      const data = JSON.parse($script.innerHTML);

      if (remove) $script.parentElement.removeChild($script);

      return data;
    } catch (error) {
      return null;
    }
  };

  const lockPage = () => {
    document.documentElement.classList.add("locked-page");
  };

  const unlockPage = () => {
    document.documentElement.classList.remove("locked-page");
  };

  const removeModal = () => {
    const $modal = document.querySelector(".protected-modal");

    if ($modal) $modal.parentElement.removeChild($modal);
  };

  const createModalForm = (password) => {
    const $form = document.createElement("form");

    $form.classList.add("protected-collection__form");

    $form.innerHTML = `
        <label for="protected-password">Password</label>
        <input type="password" name="password" id="protected-password" />
        <p class="password-errors"></p>
        <button type="submit">Submit</button>
    `;

    $form.addEventListener("submit", (event) => {
      event.preventDefault();

      const formData = new FormData(event.target);
      const submission = formData.get("password");

      if (submission === password) {
        unlockPage();
        removeModal();
      } else {
        $form.querySelector(".password-errors").textContent =
          "Password Incorrect.";
      }
    });

    return $form;
  };

  const createModal = ({
    title = "Protected Products",
    body = null,
    password = "password",
  }) => {
    const $modal = document.createElement("div");
    const $body = document.createElement("div");
    const $form = createModalForm(password);

    $modal.classList.add(...["modal", "protected-modal"]);

    $modal.innerHTML = `
        <div class="protected-modal__body">
            <h1>${title}</h1>
        </div>
    `;

    if (body) {
      $body.innerHTML = body;
      $modal.querySelector(".protected-modal__body").appendChild($body);
    }

    $modal.querySelector(".protected-modal__body").appendChild($form);
    return $modal;
  };

  const start = () => {
    const collectionHandle = location.href.split("/").reverse()[0];
    data = parseScriptTag(document.querySelector(selectors.data));

    const isProtectedCollection = data.collections.find(
      (collection) => collection.collection === collectionHandle
    );

    if (isProtectedCollection) {
      const $modal = createModal({
        title: isProtectedCollection.title,
        body: isProtectedCollection.body,
        password: isProtectedCollection.password,
      });

      document.body.appendChild($modal);
      lockPage();
    }
  };

  start();
})();
